import { useStore } from "../contexts/StoreContext";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import ScannerOnlyNotice from "./ScannerOnlyNotice";

export default function StoreCheckWrapper({ children }) {
  const { stores, isLoading, selectedStore, isScannerOnly } = useStore();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!isLoading) {
      if (
        stores?.length === 0 &&
        !isScannerOnly &&
        !location.pathname.includes("/setup")
      ) {
        navigate("/setup");
      }
    }
  }, [isLoading, stores, isScannerOnly, navigate, location.pathname]);

  // Every store they belong to is scanner-only: nothing here would load.
  if (!isLoading && isScannerOnly) {
    return <ScannerOnlyNotice />;
  }

  // If we're on stores/new page, render children immediately
  if (location.pathname.includes("/setup")) {
    return <>{children}</>;
  }

  // If still loading stores or waiting for store selection
  if (isLoading || (!selectedStore && stores?.length > 0)) {
    return (
      <div className="flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
      </div>
    );
  }

  // If we have stores and a selected store, render children
  if (stores?.length > 0 && selectedStore) {
    return children;
  }

  // Default case - show loading
  return (
    <div className="flex items-center justify-center">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
    </div>
  );
}
